var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRenew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00C48C",
    fillRule: "evenodd",
    d: "M6.5 13.91c-2.69 0-4.875-2.202-4.875-4.91 0-.826.203-1.612.569-2.29L1.008 5.514C.374 6.52 0 7.715 0 9c0 3.616 2.909 6.545 6.5 6.545V18l3.25-3.273-3.25-3.272v2.454zm0-11.455V0L3.25 3.273 6.5 6.545V4.091c2.69 0 4.875 2.2 4.875 4.909 0 .826-.203 1.612-.569 2.29l1.187 1.195C12.625 11.478 13 10.284 13 9c0-3.616-2.909-6.545-6.5-6.545z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRenew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/renew.dc0d03fc.svg";
export { ForwardRef as ReactComponent };